<template>
	<div class="day" @mouseover="isDayInfoVisible = true" @mouseleave="isDayInfoVisible = false">
		<div class="title-wrapper">
			<span class="title">{{ title }}</span>
			<div class="button-info" v-if="isDayInfoButtonVisible">
				i
			</div>
			<transition name="fade" appear mode="out-in">
				<dayInfo
					v-if="isDayInfoVisible && isDayInfoButtonVisible"
					:overBudgetPercentage="dayInfo.overBudgetPercentage"
					:currentAmount="dayInfo.currentAmount"
					:limitAmount="dayInfo.limitAmount"
					:dayInfoShifts="dayInfo.dayInfoShifts"
				/>
			</transition>
		</div>
		<span class="revenue" v-if="isLaborVisible">${{ revenueFrom }} / ${{ revenueTo }}</span>
	</div>
</template>

<script>
import dayInfo from '@/components/dayInfo';

export default {
	name: 'day',
	components: { dayInfo },
	props: {
		// contains the name of the day and the date i.e: MON 10
		title: { required: true, type: String },
		// lower limit of the daily budget
		revenueFrom: { required: true, type: String },
		// upper limit of the daily budget
		revenueTo: { required: true, type: String },
		// the index of each component on the list
		index: { required: true, type: Number },
		dayInfo: { required: false, type: Object },
		isLaborVisible: { required: false, type: Boolean, default: true },
		isDayInfoButtonVisible: { require: false, type: Boolean, default: true },
	},
	data() {
		return {
			isDayInfoVisible: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.day {
	position: relative;
	place-self: center;
	display: flex;
	flex-direction: column;
	cursor: pointer;

	.title-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title {
			font-size: 15px;
			font-weight: bold;
			color: #616e84;
			margin-right: 15px;
		}
	}
	.revenue {
		font-size: 11px;
		color: #616e84;
	}
}
</style>
